import { render } from 'react-dom';

import Root from './components/Root';

render(<Root />, document.getElementById('root'));
